module.exports = __webpack_public_path__ + "img/10.629710f1.jpg";